'use client';

import React, {FC, useState, useEffect} from "react";

type OffersFrameProps = {
    limit: number,
    product: 'credits' | 'cards' | 'deposits' | 'services' | 'insurance' | 'zaim'
}

export const OffersFrame: FC<OffersFrameProps> = ({
    limit,
    product
}) => {
    const [iframeHeight, setIframeHeight] = useState<number>(300);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // Здесь вы можете также проверить event.origin, чтобы принимать сообщения только от доверенного домена
            if (event.data && event.data.height) {
                setIframeHeight(event.data.height);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return (
        <iframe
            id="offerFrame"
            className="w-full border-none rounded-[24px] overflow-hidden bg-white"
            src={`https://newftch.ru/api/offers/html?product=${product}&limit=${limit}`}
            style={{ width: '100%', height: `${iframeHeight}px`, border: 'none', overflow: 'hidden' }}
            scrolling={'no'}
            allowFullScreen
            title="Предложения от партнёров"
        />
    )
}
